import { render, staticRenderFns } from "./effectDetailLive.vue?vue&type=template&id=a7b6c8d8&scoped=true"
import script from "./effectDetailLive.vue?vue&type=script&lang=js"
export * from "./effectDetailLive.vue?vue&type=script&lang=js"
import style0 from "./effectDetailLive.vue?vue&type=style&index=0&id=a7b6c8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b6c8d8",
  null
  
)

export default component.exports